export class ComboModel {
  public defaultFlag = false;
  public disabledFlag: boolean | null = false;
  declare public displayOrder: number;
  declare public key: string | null | undefined;
  declare public label: string | null | undefined;
  public parent: ComboModel | null = null;
  public separator = false;

  public constructor(
    key: string | null = null,
    label: string | null = null,
    disabledFlag: boolean | null = false,
    parent: ComboModel | null = null,
    defaultFlag = false,
    separator = false,
  ) {
    this.defaultFlag = defaultFlag;
    this.disabledFlag = disabledFlag;
    this.key = key;
    this.label = label;
    this.parent = parent;
    this.separator = separator;
  }

  public equals(other: ComboModel): boolean {
    if (!other) return false;
    return this.key === other.key;
  }
}
